<template>
    <div>
        <field-choice v-model="blueprint.readonly" :options="readonlyOptions" :label="label" />
        <field-condition v-model="blueprint.readonlyWhen" :label="label" :show-label="false" :form="form" :when="blueprint.readonly" />
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from '@/helpers/Decorators';
import { ReadonlyBlueprint, AlwaysChoice, NeverChoice, InternallyChoice, WhenChoice } from '../Types';
import { FormBuilder } from '../Utils';
import { Option } from '@/helpers/Interfaces';
import FieldChoice from './FieldChoice.vue';
import FieldCondition from './FieldCondition.vue';

@Options({
    name: 'field-readonly',
    components: {
        'field-choice': FieldChoice,
        'field-condition': FieldCondition
    }
})
export default class FieldReadonly extends Vue
{
    @Prop({ default: null }) public form!: FormBuilder;
    @Prop({ default: null }) public blueprint!: ReadonlyBlueprint;
    @Prop() public label!: string;

    public get uid(): string
    {
        return `form-field-${this.$.uid}`;
    }

    public get readonlyOptions(): Option<AlwaysChoice | NeverChoice | InternallyChoice | WhenChoice>[]
    {
        return [
            { value: AlwaysChoice.Always, text: '[[[Zawsze]]]' },
            { value: NeverChoice.Never, text: '[[[Nigdy]]]' },
            { value: InternallyChoice.Internally, text: '[[[Wewnętrznie]]]' },
            { value: WhenChoice.When, text: '[[[Warunkowo]]]' }
        ];
    }
}
</script>
